export const BACKUP_SHOW_RESET = 'BACKUP_SHOW_RESET'
export const BACKUP_SHOW_SET_ERROR = 'BACKUP_SHOW_SET_ERROR'
export const BACKUP_SHOW_SET_RETRIEVED = 'BACKUP_SHOW_SET_RETRIEVED'
export const BACKUP_SHOW_TOGGLE_LOADING = 'BACKUP_SHOW_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/backup/show/mutation_types.js